import classNames from "classnames";
import { ButtonHTMLAttributes, PropsWithChildren } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonType?: "primary" | "warning";
}

export const ButtonBasic = (props: ButtonProps) => {
  const { className, buttonType, ...rest } = props;

  return (
    <button
      className={classNames(
        "rounded px-2 py-1 text-sm font-semibold text-white shadow-sminline-flex",
        {
          "bg-indigo-600 hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600":
            !props.disabled && (buttonType === "primary" || !buttonType),
          "bg-yellow-600 hover:bg-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600":
            !props.disabled && buttonType === "warning",
          "bg-indigo-200 hover:bg-indigo-200": props.disabled,
        },
        className
      )}
      {...rest}
    >
      {props.children}
    </button>
  );
};
